export const CONTACT = {
  name: "Simphiwe Fudwana",
  role: "Car Sales Consultant at Toyota Tokai",
  phone: "068 103 1545",
  phoneIntl: "+27681031545",
  whatsapp: "27681031545",
  email: "sfudwana@cfaomotors.co.za",
  dealership: "Toyota Tokai",
  dealershipPhone: "021 715 3104",
  dealershipPhoneIntl: "+27217153104",
  address: ["Main Road, Tokai", "Cape Town, 7945"],
  hours: ["Mon – Fri: 08:00 – 17:30", "Sat: 08:00 – 13:00", "Sun: Closed"],
  tagline: "Good People, Great Journeys",
};

const HANDOVER_1 = "/images/handover-1.jpeg";
const HANDOVER_2 = "/images/handover-2.jpeg";
const HANDOVER_3 = "/images/handover-3.jpeg";
const HANDOVER_4 = "/images/handover-4.jpeg";

const HOME_HERO = "/images/home-hero.png";

export const IMAGES = {
  brandLogo: "/images/sf-motors-logo.png",
  // Real handover photos of Simphiwe with happy customers at Tokai Toyota
  homeHero: HOME_HERO,
  heroPortrait: HANDOVER_3,
  aboutPortrait: HANDOVER_1,
};

export const HAPPY_CUSTOMERS = [
  { image: "/images/customer-updated-1.png", caption: "Another Dream Delivered", sub: "A brand-new set of keys and a brighter tomorrow.", scale: 1, offsetY: "0%" },
  { image: "/images/customer-updated-2.png", caption: "A New Chapter Begins", sub: "Collected his new ride and ready for the road ahead.", scale: 1.2, offsetY: "-7%" },
  { image: "/images/customer-updated-4.png", caption: "Welcome to the Toyota Family", sub: "Another happy customer, another great journey ahead.", scale: 1.16, offsetY: "-3%" },
  { image: "/images/customer-updated-3.png", caption: "More Than Just a Car", sub: "Helping great people get to where they want to be.", scale: 1.3, offsetY: "-12%" },
];

export const waLink = (msg?: string) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
    msg ?? "Hi Simphiwe, I'm interested in a vehicle you have listed."
  )}`;

export const telLink = `tel:${CONTACT.phoneIntl}`;

// Email actions stay inside Simphiwe's website and take visitors directly to
// the enquiry form. The optional arguments remain for existing call sites.
type ContactEnquiry = {
  subject?: string;
  message?: string;
  vehicle?: string;
  enquiryType?: string;
};

export const contactEnquiryLink = ({ subject, message, vehicle, enquiryType }: ContactEnquiry = {}) => {
  const params = new URLSearchParams();
  if (subject) params.set("subject", subject);
  if (message) params.set("message", message);
  if (vehicle) params.set("vehicle", vehicle);
  if (enquiryType) params.set("enquiryType", enquiryType);
  const query = params.toString();
  return `/contact/${query ? `?${query}` : ""}#contact-enquiry`;
};

// Public email actions stay inside Simphiwe's website. When vehicle context is
// supplied, it is carried into the contact form instead of being discarded.
export const mailLink = (subject?: string, message?: string) =>
  contactEnquiryLink({ subject, message });
